import { array, guard } from 'decoders'
import { Item, item } from "../base"

export interface Hospital extends Item {}
export const hospitalsDecoder = guard(array(item), { style: 'simple' })

try { const _hospitals: Hospital[] = hospitalsDecoder({}) } catch(e) {}
